import { render, staticRenderFns } from "./DataTableSopimusAsiakirja.vue?vue&type=template&id=73a554a2&scoped=true&"
import script from "./DataTableSopimusAsiakirja.vue?vue&type=script&lang=js&"
export * from "./DataTableSopimusAsiakirja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a554a2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a554a2')) {
      api.createRecord('73a554a2', component.options)
    } else {
      api.reload('73a554a2', component.options)
    }
    module.hot.accept("./DataTableSopimusAsiakirja.vue?vue&type=template&id=73a554a2&scoped=true&", function () {
      api.rerender('73a554a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataTableSopimusAsiakirja.vue"
export default component.exports